
<ng-container *ngFor= "let item of menuItems" id="ng-container">
  <a id="breadcrumb">{{item.label}}</a>

</ng-container>


  
